import { styled } from '@mui/material'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
const GestaoDatagrid = styled(BasicDatagrid)(() => ({
  '.MuiDataGrid-cell:first-of-type': {
    textAlign: 'justify'
  },
  '.MuiDataGrid-columnHeader': {
    '.MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%',
      '.MuiDataGrid-columnHeaderTitle': {
        width: '100%'
      }
    }
  },
  '.MuiDataGrid-columnHeader:first-of-type': {
    '.MuiDataGrid-columnHeaderTitleContainerContent': {
      '.MuiDataGrid-columnHeaderTitle': {
        textAlign: 'justify'
      }
    }
  }
}))

export default GestaoDatagrid
